export const scrollIntoView = element => {
  element.scrollIntoView();
  const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  window.scrollBy(0, -viewportHeight / 2);
};
